import "./ControlCenter.module.css";
import Header from "@/reusable_sections/Header";
import MasteryInClimateControl from "./sections/MasteryInClimateControl";
import QuantifiableImpact from "./sections/QuantifiableImpact";
import TheSjdesignEthos from "./sections/TheSjdesignEthos";
import PrecisionCoolingServices from "./sections/PrecisionCoolingServices";
import AgenticOnboarding from "./sections/AgenticOnboarding";
import StrategicAlliances from "./sections/StrategicAlliances";
import StartYourTransition from "./sections/StartYourTransition";
import SystemFooter from "@/reusable_sections/Footer";
export default function ControlCenterPage() {
  return <div>
      <Header />
      <MasteryInClimateControl />
      <QuantifiableImpact />
      <TheSjdesignEthos />
      <PrecisionCoolingServices />
      <AgenticOnboarding />
      <StrategicAlliances />
      <StartYourTransition />
      <SystemFooter />
    </div>;
}